/**
 * アプリケーション全体のイベントリスナー管理
 * 各モジュールのイベントリスナーを統合的に初期化
 */

import { initializeAuthEventListeners } from "@/lib/auth/auth-event-listeners";
import { initializeErrorDialogEventListeners } from "@/lib/error-dialog-events";
import { initializeSystemEventListeners } from "@/lib/system/system-event-listeners";

/**
 * アプリケーション全体のイベントリスナーを初期化
 * アプリケーション起動時に一度だけ呼び出される
 */
export const initializeAllEventListeners = () => {
  // エラーダイアログ関連
  initializeErrorDialogEventListeners();

  // 認証関連
  initializeAuthEventListeners();

  // システム関連（クエリ・ナビゲーション）
  initializeSystemEventListeners();
};
